import Tour from './src/tour.vue'

import type { App } from 'vue'
import type { SFCWithInstall } from '@element-plus/utils'

Tour.install = (app: App): void => {
  app.component(Tour.name, Tour)
}

const _Tour = Tour as SFCWithInstall<typeof Tour>

export default _Tour
export const ElTourV2 = _Tour
export * from './src/tour'
export * from './src/hook'
